import * as yup from 'yup';
import docs from './attachments/specific';
import {
  parentesco,
  medicos,
  consentimentoDadosSensiveis,
  cpfResponsavelLegal,
  nomeDoTutor,
  optoPor,
  adiantamentoQuinzenal,
  acessoContraCheque,
  // acessoJornalForluz,
  consentimentoDescontoFolha,
  parcelaAVistaCondicional,
  boletoEmprestimoObrigatorio,
  abatimentoDoEmprestimoCondicional,
  retiradaAVista30,
  declaracaoCondicional,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const ContConjulgadaFinVitSchema = (saldoDevedor) => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  if (saldoDevedor) {
    return yup.object({
      ...parentesco,
      ...cpfResponsavelLegal,
      ...nomeDoTutor,
      ...medicos('medicoPerito'),
      ...medicos('medicoAssistente'),
      ...optoPor,
      ...adiantamentoQuinzenal,
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...consentimentoDescontoFolha,
      ...dadosSensiveis,
      ...parcelaAVistaCondicional,
      ...retiradaAVista30,
      ...boletoEmprestimoObrigatorio,
      ...abatimentoDoEmprestimoCondicional,
      ...declaracaoCondicional,
      ...declaracaoVeracidade,
      ...docs.ContConjulgadaDocs.rules,
      ...aceiteInss,
    });
  }

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...medicos('medicoPerito'),
    ...medicos('medicoAssistente'),
    ...optoPor,
    ...adiantamentoQuinzenal,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...consentimentoDescontoFolha,
    ...consentimentoAcertoFinanceiro,
    ...dadosSensiveis,
    ...parcelaAVistaCondicional,
    ...retiradaAVista30,
    ...declaracaoCondicional,
    ...declaracaoVeracidade,
    ...docs.ContConjulgadaDocs.rules,
    ...aceiteInss,
  });
};

export const ContConjulgadaFinVitInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  medicoPerito: '',
  medicoAssistente: '',
  optoPor: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoDadosSensiveis: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  parcelaAVista: '',
  retiradaAVista: '',
  boletoEmprestimo: '',
  abatimentoDoEmprestimo: '',
  declaracaoVeracidade: false,
  ...docs.ContConjulgadaDocs.initialValues,
};

export const ContConjulgadaFinVitDocs = {
  ...docs.ContConjulgadaDocs.docs,
};
